export function getFileSize(size) {
  const num = 1024.00;
  if (size < num) return `${size} B`;
  if (size < (num ** 2)) return `${(size / num).toFixed(2)} KB`;
  if (size < (num ** 3)) return `${(size / (num ** 2)).toFixed(2)} MB`;
  if (size < (num ** 4)) return `${(size / (num ** 3)).toFixed(2)} GB`;
  return `${(size / (num ** 4)).toFixed(2)} TB`;
}
